/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../components/common/new/InputField/InputField";
import {
  SET_CITIES,
  SET_DIVISIONS,
  SET_STATES,
  SET_SUB_DIVISIONS,
} from "../../../redux/actionTypes/meta";
import IntroductionFormApi from "../../../services/api/introductionForm";
import { isEmptyObj } from "../../../utils/helper";
import Styles from "../../friend/FriendSearch/FriendSearch.styles";
import useParamsQuery from "../../../hooks/useParamsQuery";
import { REGEX } from "../../../utils/validation/regex";

const initialFormValue = {
  dateOfBirthFrom: "",
  dateOfBirthTo: "",
  dateOfJoiningFrom: "",
  dateOfJoiningTo: "",
};

function PersonalDetailsSearch() {
  const [stateVal, setStateVal] = useState("");
  const [divisionVal, setDivisionVal] = useState("");
  const [subDivisionVal, setSubDivisionVal] = useState("");
  const [cityVal, setCityVal] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [memberId, setMemberId] = useState("");
  const [fullName, setFullName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const dispatch = useDispatch();
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);

  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      Object.keys(initialFormValue).forEach((key) => {
        setInitialAdvanceFormValue((prev) => ({
          ...prev,
          [key]: query[key] ?? "",
        }));
      });
    } else {
      setInitialAdvanceFormValue(initialFormValue);
    }
  }, [urlSearchParams.toString()]);

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
    setMetaDataInRedux(SET_DIVISIONS, response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
    setMetaDataInRedux(SET_STATES, response.data);
  };

  useEffect(() => {
    getDivisions();
    getStates();
  }, []);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setStateVal(query?.state || "");
      setCityVal(query?.city || "");
      setDivisionVal(query?.divisionId || "");
      setSubDivisionVal(query?.subdivisionId || "");
    } else {
      setStateVal("");
      setCityVal("");
      setDivisionVal("");
      setSubDivisionVal("");
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    if (states.length && stateVal) {
      const newCities =
        states.find((state) => state.stateId === Number(stateVal))?.cities ??
        [];
      setCities(newCities);
      setMetaDataInRedux(SET_CITIES, newCities);
    }
  }, [states, stateVal]);

  useEffect(() => {
    if (divisions.length && divisionVal) {
      const newSubDivisions =
        divisions.find(
          (division) => division.divisionId === Number(divisionVal)
        )?.subDivisions ?? [];
      setSubDivisions(newSubDivisions);
      setMetaDataInRedux(SET_SUB_DIVISIONS, newSubDivisions);
    }
  }, [divisions, divisionVal]);

  return (
    <Box
      sx={{
        px: 0,
        pt: 0,
        pr: { xs: "20px", sm: 0 },
        "& .MuiInputLabel-root": {
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "13px",
        },
        "& .MuiOutlinedInput-input": {
          height: "12px",
        },
      }}
    >
      <Box sx={{ pl: { xs: 0, sm: 2, md: 0 }, width: "100%" }}>
        <Grid
          container
          spacing={2}
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(4, 1fr)",
            },
            rowGap: 0,
            columnGap: 1,
          }}
        >
          {/* Group 1 - Member Id + Member Name */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            {/* <InputField
              label="Member Id"
              name="memberId"
              style={Styles.textfieldStyle}
            /> */}
            <InputField
              label="Member Id"
              name="memberId"
              value={memberId}
              style={Styles.textfieldStyle}
              onChange={(e) => {
                const { value } = e.target;
                // OLD (kept for future reference): non-digits sanitized inline
                const onlyNums = String(value).replace(
                  REGEX.NON_DIGITS_GLOBAL,
                  ""
                );
                if (onlyNums !== value) {
                  e.target.value = onlyNums;
                } else {
                  setMemberId(value);
                }
              }}
            />
            {/* <InputField
              label="Member Name"
              name="fullName"
              style={Styles.textfieldStyle}
            /> */}
            <InputField
              label="Member Name"
              name="fullName"
              value={fullName}
              style={Styles.textfieldStyle}
              onChange={(e) => {
                const { value } = e.target;
                // OLD (kept for future reference): const regex = /^[A-Za-z ]*$/;
                const regex = REGEX.NAME_ALPHA_SPACE;
                if (regex.test(value)) {
                  setFullName(value);
                }
              }}
            />
          </Grid>

          {/* Group 2 - Phone + Email */}
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              paddingRight: "8px",
              paddingBottom: "8px",
              boxShadow: "1px 0 2px 0 #e7e2e2",
            }}
          >
            {/* <InputField
              label="Phone Number"
              name="mobileNumber"
              type="text"
              style={Styles.textfieldStyle}
              inputProps={{ maxLength: 10 }}
            /> */}
            <InputField
              label="Phone Number"
              name="mobileNumber"
              type="text"
              value={mobileNumber}
              style={Styles.textfieldStyle}
              inputProps={{ maxLength: 10 }}
              onChange={(e) => {
                const { value } = e.target;
                // OLD (kept for future reference): const regex = /^[0-9]*$/;
                const regex = REGEX.DIGITS_ONLY;
                if (regex.test(value)) {
                  setMobileNumber(value);
                }
              }}
            />
            {/* <InputField
              label="Email Id"
              name="emailId"
              style={Styles.textfieldStyle}
              type="email"
            /> */}
            <InputField
              label="Email Id"
              name="emailId"
              style={Styles.textfieldStyle}
              type="email"
              onChange={(e) => {
                const { value } = e.target;
                // Allow blank OR valid email characters (no spaces allowed)
                const prev = e.target.dataset.lastValidValue ?? "";
                if (value === "" || REGEX.EMAIL_ALLOWED_CHARS.test(value)) {
                  e.target.dataset.lastValidValue = value;
                } else {
                  e.target.value = prev;
                }
              }}
            />
          </Grid>

          {/* Group 3 - Empty */}
          <Grid
            item
            sx={{
              paddingBottom: "8px",
              paddingRight: "8px",
            }}
          />

          {/* Group 4 - Empty */}
          <Grid
            item
            sx={{
              paddingBottom: "8px",
              paddingRight: "8px",
            }}
          />
        </Grid>
      </Box>
    </Box>
  );
}

export default PersonalDetailsSearch;
